import BaseApi from './base.api';

export interface Department {
  id: number;
  name: string;
  description?: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

class DepartmentApi extends BaseApi {
  async getAllDepartments(activeOnly: boolean = true): Promise<Department[]> {
    return this.get(`/departments?activeOnly=${activeOnly}`);
  }

  async getDepartmentById(id: number): Promise<Department> {
    return this.get(`/departments/${id}`);
  }
}

export default new DepartmentApi();